import util from "../../../../utils/utils";
import { useState, useCallback, useMemo, useEffect } from 'react';
import useTranslate from '../../hooks/useTranslate';
import useGetThinktankContent from '../../hooks/useGetThinktankContent';
import { LoadingDiv } from "../../../../components/LoadingDiv";
export const FileContent = (props) => {
    const {title} = props;
    const [trans,setTrans] = useState(true)
    const {getThinktankContentAction,getThinktankContentLoading } = useGetThinktankContent();
    const [data,setData] =useState()
    const [upBtnVisible,setUpBtnVisible] = useState(false)

    useEffect(()=>{
        viewFullPolicyAction(title)
    },[title])
    const viewFullPolicyAction = (fileName) => {
        reset();
        getThinktankContentAction({title:fileName})
        .then(res=>{console.log(res);setData(res)});
    }

    const reset = () => {
        document.getElementById('topAnchor').scrollIntoView();
        setTrans(true)
    }

    useEffect(()=>{
        document.getElementById("policyModalContainer")?.addEventListener("scroll",e=>{
            util?.throttle(setUpBtnStatus(),1000)
        })
    },[])

    const setUpBtnStatus = () => {
        let scrollTop = document.getElementById("policyModalContainer")?.scrollTop
        // console.log(scrollTop)
        if(scrollTop > 800){
            setUpBtnVisible(true)
        }else{
            setUpBtnVisible(false)
        }
    }

    return (
        <dialog id="my_article_modal" className="modal h-full">
            {upBtnVisible && <div id="back-to-top" className="absolute bottom-16 right-16 z-10">
                <button className="btn btn-circle btn-outline bg-base-100" 
                    onClick={()=>{
                        let element = document.getElementById("policyModalContainer");
                        element.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        })}
                    }
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l7.5-7.5 7.5 7.5m-15 6l7.5-7.5 7.5 7.5" />
                    </svg>
                </button>
            </div>}

            <div className="modal-box p-0 " id="policyModalContainer"  style={{width:'95vw',maxWidth:'95vw'}}>
                <div id="topAnchor"></div>
                <div className="bg-base-100 p-4 sticky top-0 z-50" style={{zIndex:10000}}>
                    <div className="flex space-between items-center">
                        <h2 className="card-title pl-4">
                            {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth='1.5' stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                            </svg> */}
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
                            </svg>

                            全文内容
                        </h2>
                        {
                            data && data?.language !== 'zh-CN' && <>
                                {
                                    trans ?
                                    <button className='btn btn-sm ml-6' onClick={()=>{setTrans(!trans)}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802" />
                                        </svg>
                                        原文
                                    </button> :
                                    // <button className='btn btn-sm ml-6' onClick={()=>{setTrans(!trans);translateAction({input:(data?.content_n ?? data?.content)?.replaceAll('\n','#'),source_lan:lan,target_lan:'zh-CN'})}}>
                                    <button className='btn btn-sm ml-6' onClick={()=>{setTrans(!trans)}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802" />
                                        </svg>
                                        翻译
                                    </button>
                                }
                            </>
                        }
                        <form method="dialog">
                            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"  onClick={()=>{reset()}}>✕</button>
                        </form>
                    </div>
                </div>

                <div className="overflow-auto p-2 lg:p-8 lg:pt-2">
                    <div id='modelPolicyContent'>
                        {
                            getThinktankContentLoading || !data ? 
                            <>
                            {LoadingDiv}
                            </> :
                            <>
                                {
                                    trans && data?.language !== 'zh-CN' ? 
                                    <>
                                            <div className="overflow-x-auto">
                                                <table className="table table-zebra">
                                                    <thead>
                                                        <tr>
                                                            <th>原文</th>
                                                            <th>译文</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            data?.translated_content?.split('\n')?.map((item,index)=>
                                                                <tr>
                                                                    <td><div className="text-justify">{(data?.content_n ?? data?.content)?.split('\n')[index]}</div></td>
                                                                    <td><div className="text-justify">{item}</div></td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                    </>
                                    :
                                    <div className="text-justify">
                                        <div dangerouslySetInnerHTML={{ __html:data?.content_n ?? data?.content}} style={{whiteSpace:"pre-line"}}></div>
                                    </div>
                                }
                            </>
                        }
                    </div>

                    {data?.download_link && data?.download_link?.length >0 && 
                    <div className="divider divider-start flex-1">引文下载链接</div>}
                    <div className="overflow-x-auto">
                    <table className="table">
                        <tbody>
                        {
                            data?.download_link?.map((item,index)=>(
                                <tr>
                                    <th>{index + 1}</th>
                                    <td><a className="link link-hover" onClick={(e)=>window.open(item, '_blank')}>{item}</a></td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={()=>{reset()}}>close</button>
            </form>

        </dialog>
    )
}